import { Box, styled } from '@mui/material';

export const StyledTurnaroundDataBox = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-family: 'Roboto';
    font-size: 10px;
    min-height: 15px;
`;
export const StyledTurnaroundAdesAdepBox = styled(Box)`
    color: ${({ theme }) => theme.palette.blue.lightest};
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35px;
`;
export const StyledTurnaroundAcTypeBox = styled(Box)`
    font-weight: bold;
    color: white;
    display: flex;
    align-items: center;
`;
export const StyledControlIconBox = styled(Box)`
    border-radius: 50px;
    height: 100%;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
